export default __webpack_public_path__ + "static/media/icon.207aa873.png";